import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", icon: "ri-footprint-line" },
  { name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", icon: "ri-shirt-line" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", icon: "ri-shirt-line" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", icon: "ri-star-line" },
  { name: "Pants / Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", icon: "ri-pantone-line" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", icon: "ri-user-5-line" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", icon: "ri-stack-line" },
  { name: "Underwear / Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", icon: "ri-user-3-line" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", icon: "ri-trophy-line" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", icon: "ri-glasses-line" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", icon: "ri-handbag-line" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", icon: "ri-loop-left-line" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", icon: "ri-drop-line" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", icon: "ri-more-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav
      ref={navRef}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-foreground-950/25 backdrop-blur-sm"
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 group flex-shrink-0"
          >
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-200 group-hover:scale-105">
              <span className="text-background-50 font-bold text-sm">V</span>
            </div>
            <span className={`text-lg font-bold tracking-tight font-heading transition-colors duration-300 ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}>
              Vigorbuy
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-1">
            {/* Home */}
            <Link
              to="/"
              className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                scrolled
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              <i className="ri-home-line mr-1.5"></i>
              Home
            </Link>

            {/* Shopping Guides */}
            <Link
              to="/vigorbuy-sheet-guide"
              className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                scrolled
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              <i className="ri-book-open-line mr-1.5"></i>
              Shopping Guides
            </Link>

            {/* Categories Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  scrolled
                    ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
                }`}
              >
                <i className="ri-grid-line"></i>
                Categories
                <i
                  className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${
                    dropdownOpen ? "rotate-180" : ""
                  }`}
                ></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-56 bg-background-50 rounded-lg border border-background-200/70 py-2 animate-[fadeIn_0.15s_ease-out] max-h-72 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors duration-150 whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className={`${cat.icon} text-xs text-primary-500`}></i>
                      </div>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* Vigorbuy Sheet */}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                scrolled
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              <i className="ri-external-link-line mr-1.5"></i>
              Vigorbuy Sheet
            </a>

            {/* Buy It Now */}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`ml-1 px-5 py-2 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 ${
                scrolled
                  ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-background-50 text-foreground-950 hover:bg-background-100"
              }`}
            >
              <i className="ri-shopping-cart-line mr-1.5"></i>
              Buy It Now
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors flex-shrink-0 ${
              scrolled
                ? "text-foreground-700 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/10"
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 animate-[fadeIn_0.2s_ease-out] max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            {/* Mobile Quick Links */}
            <div className="grid grid-cols-2 gap-2 mb-3">
              <Link
                to="/"
                className="flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-medium text-foreground-700 bg-background-100 rounded-lg hover:bg-background-200 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-home-line text-base"></i>
                Home
              </Link>
              <Link
                to="/vigorbuy-sheet-guide"
                className="flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-medium text-foreground-700 bg-background-100 rounded-lg hover:bg-background-200 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-book-open-line text-base"></i>
                Guides
              </Link>
            </div>

            {/* Mobile Categories */}
            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="w-full flex items-center justify-between px-3 py-3 text-sm font-semibold text-foreground-900 bg-background-100 rounded-lg"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line text-base"></i>
                Product Categories
              </span>
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${mobileCatOpen ? "rotate-180" : ""}`}></i>
            </button>

            {mobileCatOpen && (
              <div className="grid grid-cols-2 gap-1 mt-1 animate-[fadeIn_0.15s_ease-out]">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-1.5 px-3 py-2.5 text-xs text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg transition-colors"
                    onClick={() => { setMobileMenuOpen(false); setMobileCatOpen(false); }}
                  >
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className={`${cat.icon} text-[10px] text-primary-500`}></i>
                    </div>
                    <span className="truncate">{cat.name}</span>
                  </a>
                ))}
              </div>
            )}

            {/* Mobile External CTAs */}
            <div className="pt-2 border-t border-background-200/60 mt-2 space-y-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-3 py-3 text-sm font-medium bg-background-100 text-foreground-900 rounded-lg hover:bg-background-200 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-external-link-line text-base"></i>
                Vigorbuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-3 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-shopping-cart-line text-base"></i>
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </nav>
  );
}